import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    dropdownMenuFilter: {
      transform: 'translate(40px,20px)',
      marginBottom: '0px',
      '&. MuiMenu-paper': {
        maxHeigh: 'calc(100% - 300px)',
        width: '(100% + 10px)'
      },
      '& .MuiMenuItem-root': {
        color: '#2C2D3E',
        fontSize: '13px',
        '&:hover': {
          backgroundColor: 'rgba(202, 202, 252, 0.2)',
          color: '#3C419A',
        },
      },
      '& .MuiPaper-elevation8': {
        boxShadow: '0px 4px 10px rgba(44, 45, 62, 0.2)',
        borderRadius: '5px',
      },
    },
    filterListCloseText: {
      position: 'absolute',
      right: '15px',
      bottom: '12px',
      fontSize: '13px',
      color: 'rgba(44, 45, 62, 0.8)',
      cursor: 'pointer',
    },
    filterMenuCheckbox: {
      width: '14px',
      height: '14px',
      border: 'solid 1px rgba(44, 45, 62, 0.8)',
      borderRadius: '2px',
      margin: '5px 13px 5px 0px',
      cursor: 'pointer',
    },
    filterListCloseIcon: {
      display: 'relative',
      margin: '0px 10px',
      width: '18px',
      color: 'rgba(44, 45, 62, 0.8)',
      cursor: 'pointer',
    },
    hr: {
      margin: '5px 0px',
    },
    filterCloseText: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '2px 20px 2px 0px',
    },
    icon: {
      paddingRight: '5px',
    },
    radioButton: {
      width: '10px',
      height: '10px',
      '&, &.Mui-checked': {
        color: '#3C419A',
      },
    },
    menuSubheader: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      color: '#2C2D3E',
      margin: '12px 10px 8px 15px',
      fontSize: '13px',
    }  
  }),
);
